import React from 'react';
import { bool, string, func } from 'prop-types';
import { connect } from 'react-redux';
import { UTLabel } from '@widergy/energy-ui';

import { actionCreators as alertActions } from '../../../redux/alertHandlers';
import UTModal from '../UTModal';
import { message } from '../../../utils/stringUtils';

import styles from './styles';

const UTAlertModal = ({ modalIsOpen, modalTitle, modalContent, dispatch, onDismiss }) => {
  const handleCloseModal = () => {
    dispatch(alertActions.closeModal());
    if (onDismiss) onDismiss();
  };

  return (
    <UTModal
      isOpen={modalIsOpen}
      title={modalTitle || message('FormCreator:defaultAlertModalTitle')}
      acceptButton={{
        text: message('Commons:accept'),
        onPress: handleCloseModal
      }}
    >
      <div style={styles.modalContent}>
        <UTLabel style={styles.textInputSize}>{modalContent}</UTLabel>
      </div>
    </UTModal>
  );
};

UTAlertModal.propTypes = {
  modalIsOpen: bool,
  modalTitle: string,
  modalContent: string,
  onDismiss: func
};

const mapStateToProps = store => ({
  modalIsOpen: store.alert.alertModalOpen,
  modalTitle: store.alert.alertModalTitle,
  modalContent: store.alert.alertModalContent,
  onDismiss: store.alert.alertOnDismiss
});

export default connect(mapStateToProps)(UTAlertModal);
